import { Component, PropTypes } from 'react';
// We can remove the sendLinkText, phonePreviewText, and desktopSticky as well.
class SmartAppBanner extends Component {
  static propTypes = {
    branchKey: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    openAppButtonText: PropTypes.string,
    downloadAppButtonText: PropTypes.string,
    showiOS: PropTypes.bool,
    showiPad: PropTypes.bool,
    showAndroid: PropTypes.bool,
    showBlackberry: PropTypes.bool,
    showWindowsPhone: PropTypes.bool,
    showKindle: PropTypes.bool,
    showDesktop: PropTypes.bool,
    iframe: PropTypes.bool,
    disableHide: PropTypes.bool,
    forgetHide: PropTypes.bool,
    respectDNT: PropTypes.bool,
    mobileSticky: PropTypes.bool,
    desktopSticky: PropTypes.bool,
    makeNewLink: PropTypes.bool,
    openApp: PropTypes.bool,
    theme: PropTypes.string
  }

  static defaultProps = {
    branchKey: '',
    icon: '',
    title: '',
    description: '',
    openAppButtonText: 'Open',
    downloadAppButtonText: 'Download',
    showiOS: true,
    showiPad: false,
    showAndroid: true,
    showBlackberry: false,
    showWindowsPhone: false,
    showKindle: false,
    showDesktop: false,
    iframe: true,
    disableHide: false,
    forgetHide: false,
    respectDNT: false,
    mobileSticky: false,
    desktopSticky: true,
    makeNewLink: false,
    openApp: false,
    theme: 'light'
  }

  componentWillMount() {
    if (process.env.BROWSER) {
      if (!window['branch'] || !window['branch']._q) {
        const child = document.createElement('script');
        const parent = document.getElementsByTagName('head')[0];
        child.type = 'text/javascript';
        child.src = 'https://cdn.branch.io/branch-latest.min.js';
        child.async = 1;
        parent.appendChild(child);

        window['branch'] = { _q: [], _v: 1 };

        const branch = window['branch'];

        branch.init = function() {
          branch._q.push(['init', arguments]);
        };

        branch.banner = function() {
          branch._q.push(['banner', arguments]);
        };

        const { branchKey } = this.props;
        branch.init(branchKey);

        const {
          icon,
          title,
          description,
          openAppButtonText,
          downloadAppButtonText,
          showiOS,
          showiPad,
          showAndroid,
          showBlackberry,
          showWindowsPhone,
          showKindle,
          showDesktop,
          iframe,
          disableHide,
          forgetHide,
          respectDNT,
          mobileSticky,
          desktopSticky,
          makeNewLink: make_new_link,
          openApp: open_app,
          theme
        } = this.props;

        branch.banner({
          icon,
          title,
          description,
          openAppButtonText,
          downloadAppButtonText,
          showiOS,
          showiPad,
          showAndroid,
          showBlackberry,
          showWindowsPhone,
          showKindle,
          showDesktop,
          iframe,
          disableHide,
          forgetHide,
          respectDNT,
          mobileSticky,
          desktopSticky,
          make_new_link,
          open_app,
          theme
        });
      }
    }
  }

  render() {
    return null;
  }
}

export default SmartAppBanner;



// WEBPACK FOOTER //
// ./app/components/ads/SmartAppBanner.js